import * as React from "react";
import Divider from "@mui/material/Divider";
import { useSidebar } from "../../context/sidebar-provider";
import { getDrawerSxTransitionMixin } from "./mixins";

const SidebarDividerItem = () => {
  const { fullyExpanded = true, hasDrawerTransitions } = useSidebar();

  return (
    <li>
      <Divider
        sx={{
          borderBottomWidth: 1,
          my: 1,
          mx: -0.5,
          ...(hasDrawerTransitions
            ? getDrawerSxTransitionMixin(fullyExpanded, "margin")
            : {}),
        }}
      />
    </li>
  );
};

export default SidebarDividerItem;
